import React, { useEffect, useState, useRef, useCallback } from 'react';
import Accordion from 'b2b-ui-components-lib/lib/components/accordion';
import RadioGroup from 'b2b-ui-components-lib/lib/components/radioGroup';
import Input from 'b2b-ui-components-lib/lib/components/input';
import RoundLoader from 'b2b-ui-components-lib/lib/components/roundLoader';
import TextArea from 'b2b-ui-components-lib/lib/components/textarea';
import { isformValid } from '../../../../common/utils/validator';
import { fetchAccountDetailsByAccountNumber, fetchBCPs, fetchCityStateList, fetch_BA_Accounts } from '../../../../common/services/http.service';
import { addresses, ADDRESS_TYPE_ENUM, formElement } from '../summary.constant';
import Select from 'b2b-ui-components-lib/lib/components/select';
import Autocomplete from 'b2b-ui-components-lib/lib/components/autocomplete';
import { prepareOptionsForDropDown } from '../../../services/summary.service';
import { handleError, numberSort, showServiceError, removeAsciiCode, filterAccounts, getFromSessionStorage, addressRegexValidator } from 'common/utils/app.utils';
import Tooltip from 'common/components/tooltip-component/tooltip-component';
import { MULTI_SITE_MODULE_ID, SUMMARY_AUTH_TOKEN, TOOLTIP_MESSAGE } from 'home/view/manage-feasibility/constants/multiSite-constants';
import debounce from 'lodash.debounce';
import { createUpdateKdmDetailsHandlerAOI } from 'tokenGeneration/response.handler';
import { updateOrderForSummary } from 'home/view/manage-feasibility/services';
import './addressDetailsAOI.scss';

const AddressDetailsAOI = ({ order, accordionMetadataAddress, setAccordionMetadataAddress, formAdd, setformAdd }) => {
  //   const formSchema = {
  //     pinCode: {...formElement},
  //     city: {...formElement},
  //     address: {...formElement}
  //   }
  const [cityList, setCityList] = useState([]);
  const [addressList, setAddressList] = useState([]);
  //   const [formAdd, setformAdd] = useState(formSchema)
  const [bcpIdList, setBCPsList] = useState([]);
  const bcpCompleteList = useRef([]);
  const [showLoader, setShowLoader] = useState(false);
  const [poIdsList, setPoIdsList] = useState([]);
  //   const [addressDetailsAccordion, setAddressDetailsAccordion] = useState(false)
  const [accountNumbers, setAccountNumbers] = useState([]);
  const errorMsg = ['Please Enter Valid Pincode'];
  const errorMsgAddress = ['Please Enter Valid Address'];
  const [showErrorMsg, setShowErrorMsg] = useState(false);
  const [showErrorMsgAddress, setShowErrorMsgAddress] = useState(false);
  const [pinCodeErrorMsg, setPinCodeErrorMsg] = useState('');
  const [showPinCodeErrorMsg, setShowPinCodeErrorMsg] = useState(false);

  // setting default values of formSchema if they are present in order
  const orderAuthToken = getFromSessionStorage(MULTI_SITE_MODULE_ID, SUMMARY_AUTH_TOKEN);
  const defaultValueSetter = (order) => {
    const billingAddressAOI = order?.billingAddress;
    const defaultPinCode = billingAddressAOI?.pincode;
    var defaultCity = billingAddressAOI?.city;
    const defaultAddress = billingAddressAOI?.addressLine1;
    // const defaultCity = ['gurgaon'];
    const defaultCityArr = [];
    defaultCityArr.push(defaultCity);
    setCityList(defaultCityArr);
    if (defaultCityArr.length === 1) {
      onCityChange(defaultCityArr[0]);
    }
    var index = 0;
    for (var i = 0; i < defaultCityArr.length; i++) {
      if (defaultCityArr[i] === defaultCity) {
        index = i;
      }
    }

    if (defaultPinCode && defaultCity && defaultAddress) {
      // setAddressDetailsAccordion(true)
      setAccordionMetadata({
        ...accordionMetadata,
        isValidated: true
      });
      setformAdd({
        ...formAdd,
        pinCode: {
          ...formAdd.pinCode,
          value: defaultPinCode,
          touched: true
        },
        address: {
          ...formAdd.address,
          value: defaultAddress,
          touched: true
        },
        city: {
          ...formAdd.city,
          value: defaultCityArr[index],
          touched: true
        }
      });
    }
  };

  const pinCodeValidator = (value) => /^[0-9][0-9]{5}$/.test(value);

  const onCityChange = (value) => {
    console.log('city changed');
    setformAdd({ ...formAdd, city: { ...formAdd.city, value, touched: true } });
    // updateAddressCallHandler();
    // accordionValidator();
  };

  const accordionValidator = () => {
    // ;
    if (formAdd.address?.value?.length > 4 && formAdd.city?.value?.displayName && formAdd.pinCode?.value?.length === 6) {
      setAccordionMetadataAddress({
        ...accordionMetadataAddress,
        isValidated: true
      });
    } else {
      setAccordionMetadataAddress({
        ...accordionMetadataAddress,
        isValidated: false
      });
    }
  };

  const onAddressChange = (value) => {
    if ((value.length >= 1 && value[value.length - 1] === '') || addressRegexValidator(value)) {
      setformAdd({ ...formAdd, address: { ...formAdd.address, value, touched: true } });
    }
    // setformAdd({ ...formAdd, address: { ...formAdd.address, value, touched: true } });
    // console.log(value)
    // accordionValidator();
  };

  const onPinCodeChange = (value) => {
    // var cityList = [];
    const oldPincodeValue = formAdd?.pinCode?.value;
    let newValue = value;
    if (value.length === 1 && !(value >= 0 && value <= 9)) {
      newValue = '';
    } else if (!(value[value.length - 1] >= 0 && value[value.length - 1] <= 9)) {
      newValue = oldPincodeValue;
    }
    if (value === '') {
      newValue = value;
    }
    setformAdd({
      ...formAdd,
      //   pinCode: { ...formAdd.pinCode, value, touched: true, errors: formAdd.pinCode.validator(value) },
      pinCode: { ...formAdd.pinCode, value: newValue, touched: true },
      city: { ...formAdd.city, value: '', touched: true },
      address: { ...formAdd.address, value: '', touched: true }
    });

    if (!pinCodeValidator(value)) {
      setShowErrorMsg(true);
      setShowPinCodeErrorMsg(false);
    } else {
      setShowErrorMsg(false);
      // setShowPinCodeErrorMsg(true)
    }
    //   accordionValidator();
  };

  useEffect(() => {
    accordionValidator();
  }, [formAdd]);

  useEffect(() => {
    if (formAdd.pinCode?.value?.length === 6) {
      setShowLoader(true);
      fetchCityStateList(formAdd.pinCode.value, { productName: 'DSL' }).then(
        (res) => {
          setShowLoader(false);
          if (res?.data?.result) {
            console.log(res, 'res');
            // { data: { result } }
            const result = res?.data?.result;
            if (Array.isArray(result)) {
              setformAdd({
                ...formAdd,
                pinCode: { ...formAdd.pinCode, touched: true, errors: [] },
                city: { ...formAdd.city, value: '', touched: true },
                address: { ...formAdd.address, value: '', touched: true }
              });
              const cityList = prepareOptionsForDropDown(result, 'city');
              setCityList(cityList);
              if (cityList.length === 1) {
                onCityChange(cityList[0]);
              }
            }
            setShowErrorMsg(false);
          } else {
            setShowErrorMsg(true);
            // console.log(res, "error")
            // console.log(err, "error")
          }
        },
        (err) => {
          let errMsg = err && err.response && err.response.data && err.response.data.errorMsg;
          setPinCodeErrorMsg(errMsg);
          setShowPinCodeErrorMsg(true);
          setShowErrorMsg(false);
          setCityList([]);
          setformAdd({
            ...formAdd,
            pinCode: { ...formAdd.pinCode, touched: true, errors: [errMsg ? errMsg : 'Please enter valid Pincode'] },
            city: { ...formAdd.city, value: '', touched: true },
            address: { ...formAdd.address, value: '', touched: true }
          });
          console.error(err);
        }
      );
    }
  }, [formAdd.pinCode.value]);

  useEffect(() => {
    // defaultValueSetter(order);
  }, []);

  const prepareAddressPayload = (formAdd) => {
    const request = {};
    const payload = {};

    request['addressLine1'] = formAdd.address.value;
    request['city'] = formAdd.city.value.displayName;
    request['pinCode'] = formAdd.pinCode.value;

    payload['billingAddress'] = request;

    return payload;
  };

  const updateAddressCallHandler = () => {
    if (formAdd?.address?.value && formAdd?.city?.value && formAdd?.pinCode?.value) {
      const payload = prepareAddressPayload(formAdd);
      updateOrderForSummary(payload, orderAuthToken).then(
        (res) => {},
        (error) => {
          handleError(error);
        }
      );
    }
  };

  const onFieldBlur = (formElement, keyName) => {
    const { value, validator, errors: existingError } = formElement;
    let errors = [];
    if (typeof validator === 'function') {
      errors = validator(value);
    }
    setformAdd({ ...formAdd, [keyName]: { ...formAdd[keyName], value, errors: errors.concat(existingError), touched: true } });
    // updateAddressCallHandler();
  };

  return (
    <React.Fragment>
      <Accordion
        title="Billing address Details"
        autoScrollOnExpand={false}
        isExpanded={true}
        isValidated={accordionMetadataAddress.isValidated}
        // isEditable= {accordionMetadata.isEditable}
        // onEditClick={() => setAccordionMetadata(({ isEditable }) => ({ ...accordionMetadata, isEditable: !isEditable }))}
      >
        <div className="accordion_body">
          <React.Fragment>
            <div className="row field_row">
              <div className="flg-lg-6 flg-md-6">
                <Input
                  label="Pincode"
                  maxlength={6}
                  //   value={'110084'}
                  value={formAdd && formAdd.pinCode && formAdd.pinCode.value ? formAdd.pinCode.value : ''}
                  // isValidChange={(value) => /^[1-9][0-9]{5}$/.test(value)}
                  onBlur={() => onFieldBlur(formAdd.pinCode, 'pinCode')}
                  required
                  // errors={formAdd.pinCode.errors}
                  touched={formAdd.pinCode.touched}
                  onChange={onPinCodeChange}
                  helpTexts={showErrorMsg && errorMsg}
                  //   disabled={isOrderConfirmation || formAdd.selected.value.id === BILLING_TYPES_IDs.EXISTING}
                  //   disabled = {addressDetailsAccordion}
                />

                {/* {showLoader && <div class="loader"></div>} */}
              </div>
              {showLoader && (
                <div className="default-loader">
                  <RoundLoader />
                </div>
              )}
              <div className="flg-lg-6 flg-md-6">
                <Select
                  label="City"
                  value={formAdd.city.value}
                  onChange={onCityChange}
                  options={cityList}
                  placeholder="City"
                  required
                  //   disabled={isOrderConfirmation || formAdd.selected.value.id === BILLING_TYPES_IDs.EXISTING}
                  //   disabled = {addressDetailsAccordion}
                />
              </div>
            </div>
            <div className="row field_row">
              <div className="flg-lg-12">
                <TextArea
                  label="Address"
                  maxlength={250}
                  required
                  value={formAdd.address.value}
                  onBlur={() => onFieldBlur(formAdd.address, 'address')}
                  errors={formAdd.address.errors}
                  touched={formAdd.address.touched}
                  onChange={onAddressChange}
                  //   disabled = {addressDetailsAccordion}
                  //   disabled={isOrderConfirmation || formAdd.selected.value.id === BILLING_TYPES_IDs.EXISTING}
                />
              </div>
              {/* <div style={{ position: 'relative' }}>
                        <small id="helpId" className="help-text-counter">
                          {(formAdd.address.value && formAdd.address.value.length) || 0} /250
                        </small>
                      </div> */}
            </div>
          </React.Fragment>
        </div>
      </Accordion>
    </React.Fragment>
  );
};

export default AddressDetailsAOI;
